var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      widthClass: "max-1000",
      title: _vm.$t("label_essweb_eventPropertyGroup_form_newTitle"),
      pad: "0",
      initData: _vm.eventPorpertyGroupData,
      checkData: [
        "event_property_group_name",
        "event_property_group_description",
        "event_property_group_code",
        "remarks",
      ],
    },
    on: {
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Stepper", {
              attrs: { curStep: _vm.curStep, items: _vm.stepper },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "white lighten-5",
                              attrs: { align: "center", justify: "start" },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      maxlength: "100",
                                      bindData:
                                        _vm.eventPorpertyGroupData
                                          .event_property_group_name,
                                      label: _vm.$t(
                                        "label_essweb_eventPropertyGroup_form_eventPropertyGroupNameLabel"
                                      ),
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.eventPorpertyGroupData.event_property_group_name =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      bindData:
                                        _vm.eventPorpertyGroupData
                                          .event_property_group_description,
                                      maxlength: "500",
                                      label: _vm.$t(
                                        "label_essweb_eventPropertyGroup_form_eventPropertyGroupDescriptionLabel"
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.eventPorpertyGroupData.event_property_group_description =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                      label: _vm.$t(
                                        "label_essweb_eventPropertyGroup_form_eventPropertyGroupCodeLabel"
                                      ),
                                      maxlength: "100",
                                    },
                                    model: {
                                      value:
                                        _vm.eventPorpertyGroupData
                                          .event_property_group_code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.eventPorpertyGroupData,
                                          "event_property_group_code",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "eventPorpertyGroupData.event_property_group_code",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    { staticClass: "text--secondary" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "label_essweb_eventPropertyGroup_form_remarkLabel"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("v-textarea", {
                                    attrs: {
                                      rows: "5",
                                      "no-resize": "",
                                      maxlength: "500",
                                      filled: "",
                                      dense: "",
                                      counter: "500",
                                      "single-line": "",
                                      name: "input-7-4",
                                    },
                                    model: {
                                      value: _vm.eventPorpertyGroupData.remarks,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.eventPorpertyGroupData,
                                          "remarks",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "eventPorpertyGroupData.remarks",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _c("PropertyList", {
                        attrs: {
                          items: _vm.desserts,
                          listdata: _vm.PropertyListData,
                        },
                        on: { edit: _vm.toEditProperty },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: {
                newBtn:
                  _vm.step == _vm.curStep && _vm.curStep != 0 ? true : false,
                step: _vm.step == _vm.curStep ? false : true,
                preStep: _vm.curStep > 1 ? true : false,
              },
              on: {
                next: _vm.toNext,
                pre: function ($event) {
                  _vm.curStep = _vm.curStep - 1
                },
                new: _vm.toAdd,
                cancel: function ($event) {
                  return _vm.$toBack(_vm.isChanged)
                },
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("MappingPopup2", {
              attrs: {
                show: _vm.showMappingPopup,
                PropertyData: _vm.PropertyData,
              },
              on: {
                close: function ($event) {
                  _vm.showMappingPopup = false
                  _vm.PropertyData = null
                },
                confirm: _vm.onEditProperty,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }